import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
import Draft from './models/Draft';
export default [new Extend.Routes() //
.add('drafts', '/drafts', () => import(/* webpackChunkName: 'forum/components/DraftsPage', webpackMode: 'lazy-once' */ './components/DraftsPage').then(module => module.default)), new Extend.Store() //
.add('drafts', Draft), new Extend.Model(User) //
.hasMany('drafts').attribute('draftCount')];flarum.reg.addChunkModule('217', '319', 'fof-drafts', 'forum/components/DraftsPage');